module.exports = __webpack_public_path__ + "static/twitter-btn-a65d6361f86960eb32ab9e9bdebeb7a1.svg";